module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Repeat-one-c44c65509fefb184ddb9ecd25f469b7b.svg";